import { TOP_BAR_HEIGHT } from "@/components/layout/components/constants";
import { MDSButton, MDSButtonVariant, MDSLogo, MDSLogoKind } from "@/mds";
import styled from "@emotion/styled";
import { noop } from "lodash-es";
import { usePublicAppStore } from "@/store";
import { PanelMode } from "@/mds/foundations";

export const GuestModeTopBar = () => {
  const { publicStore } = usePublicAppStore();
  const isNarrowView = !!publicStore.interface.matchesPanelModeBreakpoint.get(PanelMode.Narrow);
  return (
    <Wrapper>
      <StyledLogoButton
        variant={MDSButtonVariant.Transparent}
        onClick={noop}
        $isSidePanelOpen={true}
        $isNarrowView={isNarrowView}
      >
        <StyledLogo $isSidePanelOpen={true}>
          <MDSLogo kind={MDSLogoKind.Lockup} />
        </StyledLogo>
      </StyledLogoButton>
    </Wrapper>
  );
};

const Wrapper = styled.div(({ theme }) => ({
  width: "100%",
  paddingRight: theme.spacing["2"],
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  height: `${TOP_BAR_HEIGHT}px`,
  WebkitAppRegion: "drag",
  overflow: "hidden",
  paddingBlock: theme.spacing["2"],
  flexShrink: 0,
}));

const StyledLogoButton = styled(MDSButton)<{ $isSidePanelOpen: boolean; $isNarrowView: boolean }>`
  padding-top: ${({ theme }) => theme.spacing["5"]};
  padding-bottom: ${({ theme }) => theme.spacing["5"]};
  padding-left: ${({ theme, $isNarrowView }) =>
    $isNarrowView ? theme.spacing["1"] : theme.spacing["5"]};
  padding-right: ${({ theme, $isNarrowView }) =>
    $isNarrowView ? theme.spacing["2"] : theme.spacing["5"]};

  color: ${({ theme, $isSidePanelOpen, $isNarrowView }) =>
    $isSidePanelOpen
      ? $isNarrowView
        ? theme.colors.icon.brand
        : theme.colors.text.contrast
      : theme.colors.icon.onChromeInactive};
  &[data-hovered]:not([data-disabled]) {
    background-color: transparent;
    color: ${({ theme, $isSidePanelOpen }) =>
      !$isSidePanelOpen ? theme.colors.icon.brand : "auto"};
  }
`;

const StyledLogo = styled.div<{ $isSidePanelOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    background: transparent;
  }
`;
